import { fetch } from "@/src/lib/fetch";
import { User, useUserStore } from "@/src/stores/userStore";

export async function verifyLogin(token: string, email: string) {
    const res = await fetch<{ user: User }>("/api/auth/login", "POST", { token, email });

    useUserStore.getState().setUser(res.user);
    localStorage.setItem("user", JSON.stringify(res.user));

    return res.user;
}